export function success(message: string) {
    alert(message);
}